import axios from 'axios';
import DEPLOYMENT_CONFIG from '../config/deployment';

// API base configuration - same as main API service
const API_BASE_URL = DEPLOYMENT_CONFIG.getBackendUrl();

export interface MeoPortalResponse {
  success: boolean;
  message: string;
  session_id?: string;
}

export interface MeoPortalStatus {
  active: boolean;
  session_id?: string;
  user?: string;
}

export interface MeoPortalSession {
  session_id: string;
  crm_user: string;
  created_at: string;
  last_activity: string;
}

export interface MeoPortalSessionsResponse {
  success: boolean;
  sessions: MeoPortalSession[];
  count: number;
}

class MeoPortalService {
  private baseUrl = `${API_BASE_URL}/meo-portal`;

  private getAuthHeaders() {
    const token = localStorage.getItem('jwt_token');
    return token ? { Authorization: `Bearer ${token}` } : {};
  }

  async login(): Promise<MeoPortalResponse> {
    try {
      const response = await axios.post(`${this.baseUrl}/login`, {}, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 403) {
        return {
          success: false,
          message: 'Acesso negado - Sem permissão para o Portal MEO'
        };
      }
      throw error;
    }
  }

  async getStatus(): Promise<MeoPortalStatus> {
    try {
      const response = await axios.get(`${this.baseUrl}/status`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async releaseSession(): Promise<MeoPortalResponse> {
    try {
      const response = await axios.post(`${this.baseUrl}/release`, {}, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async forceTerminateSession(targetUser?: string): Promise<MeoPortalResponse> {
    try {
      const payload = targetUser ? { target_user: targetUser } : {};
      const response = await axios.post(`${this.baseUrl}/force-terminate`, payload, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  async getActiveSessions(): Promise<MeoPortalSessionsResponse> {
    try {
      const response = await axios.get(`${this.baseUrl}/sessions`, {
        headers: this.getAuthHeaders()
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  getPortalUrl(): string {
    // Return the real MEO portal URL to open in new window
    return DEPLOYMENT_CONFIG.MEO_PORTAL_URL;
  }
}

export default new MeoPortalService(); 